export const SORT_METHODS_PRODUCTS = [
  {
    value: {
      id: 'sortItem.position',
      text: 'Mais relevantes',
      attribute: 'position',
      sortDirection: 'ASC'
    },
    label: 'Mais relevantes'
  },
  {
    value: {
      id: 'sortItem.priceAsc',
      text: 'Menores preços',
      attribute: 'price',
      sortDirection: 'ASC'
    },
    label: 'Menores preços'
  },
  {
    value: {
      id: 'sortItem.priceDesc',
      text: 'Maiores preços',
      attribute: 'price',
      sortDirection: 'DESC'
    },
    label: 'Maiores preços'
  }
] as const;
